import Axios from "axios";

export const fetcher = (url) => Axios.get(url).then((res) => res.data);
export const fetcherAuth = (url, token) =>
  Axios.get(url, { headers: { Authorization: "Bearer " + token } }).then(
    (res) => res.data
  );
